import src from "IMAGE";
export default { src, width: 197, height: 140, blurWidth: 0, blurHeight: 0};
